import { css } from 'styled-components';

const styles = css`
  .header-info {
    padding: ${(props) => (props.isDesktopProductTileCleanUpDisabled ? '12px' : '12px 16px')};
    border-radius: 10px;
    border: ${(props) =>
      props.isDesktopProductTileCleanUpDisabled
        ? `2px solid ${props.theme.colorPalette.orange[800]}`
        : `1px solid ${props.theme.colorPalette.orange[800]}`};
    ${(props) =>
      !props.isDesktopProductTileCleanUpDisabled &&
      `border-left: 6px solid ${props.theme.colorPalette.orange[800]};`}
    background: #fff;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      align-items: start;
    }
  }
  .container-heading-left-section {
    display: flex;
    align-items: center;
  }
  .total-items {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
  }
  .info-notification {
    box-sizing: border-box;
    display: inline-block;
    width: 32px;
    height: 32px;
    left: 0;
    top: 8px;
    background: #f7971f;
    border: 1px solid #f7971f;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    margin: 0 5px;
    padding: 0px 0;
    font-size: 22px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: 20px;
      height: 20px;
      font-size: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
    }
  }
  .boss-list-container {
    background-color: white;
    padding: ${(props) =>
      props.isDesktopProductTileCleanUpDisabled ? '32px 25px 25px 25px' : '32px 25px 0px 25px'};
    border-radius: 10px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: 20px 8px 12px;
    }
  }
  .container-heading {
    display: flex;
    align-items: center;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      justify-content: space-between;
    }
  }
  .text-capitalize {
    text-transform: capitalize;
  }

  .free-ship-message {
    color: #26762c;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Nunito;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    padding: 4px 0px;
    align-items: center;
    gap: 8px;
    margin-left: 46px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: ${(props) => (props.isPDP ? '14px' : '0px')};
      margin-top: 0px;
      font-size: 14px;
    }
  }
  .free-ship-anchor {
    color: var(--GREY-Gray-Dark, #595959);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      font-size: 12px;
    }
  }
  ${(props) =>
    !props.isDesktopProductTileCleanUpDisabled &&
    `@media ${props.theme.mediaQuery.medium} {
    .boss-unavailable-tile-container {
      :last-child .product-tile-container {
        border: none;
      }
    }
  }`}

  ${(props) =>
    `@media ${props.theme.mediaQuery.smallOnly} {
    .boss-unavailable-tile-container {
      :last-child .product-tile-container {
        border: none;
      }
    }
  }`}
`;

export default styles;
